import axios, { AUTH_PREFIX } from 'src/clients/axios';

export const authLogout = () => {
  return axios.post(`${AUTH_PREFIX}/auth/logout`, undefined, {
    onlyProduction: true,
  });
};

export const stgAuthLogout = () => {
  return axios.post(`${AUTH_PREFIX}/auth/logout`, undefined, {
    onlyStaging: true,
  });
};
